<template>
  <div class="">
    <span v-if="discountType === 'code'">
      A {{ fakeDiscountVisualOnly }}% Discount has been applied
    </span>
    <span v-else-if="discountType === 'partner'">
      Your exclusive {{ fakeDiscountVisualOnly }}%
      <span class="partner-slug"> {{ partnerLabel }} </span> discount has been
      applied!

      <div v-if="discountSlug === 'vivup'">
        <img
          src="~/assets/images/free-partner-logos/vivup.png"
          class="free-partner-logo"
          alt="free-partner-logo"
        />
      </div>
      <div v-if="discountSlug === 'enjoybenefits'">
        <img
          src="~/assets/images/free-partner-logos/enjoy-benefits.png"
          class="free-partner-logo"
          alt="free-partner-logo"
        />
      </div>
    </span>
    <span v-else>
      <!-- As a new customer you have {{ fakeDiscountVisualOnly }}% discount -->
    </span>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'DisplayDiscount',
  filters: {
    removeDashes: (value) => {
      if (!value) {
        return ''
      }
      value = value.replace(/-/g, ' ')
      return value
    },
  },
  data: () => {
    return {
      discountCode: '',
    }
  },
  computed: {
    ...mapGetters({
      discountType: 'quote/discountType',
      fakeDiscountVisualOnly: 'quote/fakeDiscountVisualOnly',
      discountError: 'quote/discountError',
      discountSlug: 'quote/discountSlug',
      partnerLabel: 'quote/partnerLabel',
    }),
    discountLoading() {
      return this.$store.getters['quote/isDiscountLoading']
    },
  },
  methods: {
    ...mapActions('quote', {
      applyCodeDiscount: 'getCodeDiscount',
    }),
  },
}
</script>

<style lang="scss" scoped>
.fullwidth {
  width: 100%;
}
.discount {
  padding-bottom: 5px;
  span {
    text-decoration: underline;
    cursor: pointer;
  }
}
.partner-slug {
  text-transform: capitalize;
}
.free-partner-logo {
  max-width: 350px;
  display: block;
  margin: 0 auto;
}
</style>
